var _defs, _circle, _circle2, _circle3, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaaBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    role: "img",
    "aria-label": "FAA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faaRing",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A4F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#063A6B"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 76,
    fill: "url(#faaRing)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 68,
    fill: "none",
    stroke: "#F5C518",
    strokeWidth: 3.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 60,
    fill: "#0A4F8C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    transform: "translate(80 66)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 20,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 -1.5 L-26 -12 L-22 -1.5 L-26 9 L-3 1.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 -1.5 L26 -12 L22 -1.5 L26 9 L3 1.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5 L20 14 L15 14 L9 3.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 1.5 L-20 14 L-15 14 L-9 3.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 2.5 L0 16 L5 2.5 Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 112,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: 3,
    fill: "#FFFFFF"
  }, "FAA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaaBadge);
export default __webpack_public_path__ + "static/media/FAA_Badge.16d224b4a6a6e7a7c78e05c1a95c6e03.svg";
export { ForwardRef as ReactComponent };